import { FC, ReactElement, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Icon } from '@flatfile/baseline'
import { OAuth } from '../../auth/oauth'
import { useEntitlements } from '../../hooks/useEntitlements'
import { useIdentity } from '../../hooks/useIdentity'
import type { Identity } from '../../api/types/Identity'

export const shouldShowProfileMenuItem = (identity: Identity) => {
  return !identity.user?.idp || identity.user.idp?.toLowerCase() === 'frontegg'
}

export const UserDropdownMenu: FC<{ children: ReactElement }> = ({ children }) => {
  const { identity, hasPermission } = useIdentity()
  const { hasEntitlement } = useEntitlements()
  /* const billingEnabled =
    hasEntitlement('billingEnabled') &&
    hasPermission({ resource: identity.account, permissionKey: 'account:manage-billing' }) */
  const manageUsers =
    hasEntitlement('manageUsers') &&
    hasPermission({ resource: identity.account, permissionKey: 'account:manage-users' })

  const showProfileMenuItem = shouldShowProfileMenuItem(identity)

  const nav = useNavigate()

  const logoutAction = useCallback(() => {
    OAuth.logout()
  }, [])

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent>
        {showProfileMenuItem && (
          <DropdownMenuItem
            onClick={() => {
              nav('/account')
            }}
          >
            <Icon name='people' className='mr-2' size={18} />
            Profile
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={() => {
            nav('/personal-access-tokens')
          }}
        >
          <Icon name='shield-check' className='mr-2' size={18} />
          Personal Access Tokens
        </DropdownMenuItem>

        {/* Commented out because everyone has been moved from Stripe to Sequence and the billing page no longer works as intended
        {billingEnabled && (
          <DropdownMenuItem
            onClick={() => {
              nav('/billing')
            }}
          >
            <Icon name='page-text' className='mr-2' size={18} />
            Manage Billing
          </DropdownMenuItem>
        )} */}

        {manageUsers && (
          <DropdownMenuItem
            onClick={() => {
              nav('/users')
            }}
          >
            <Icon name='group-1' className='mr-2' size={18} />
            Manage Users
          </DropdownMenuItem>
        )}

        <DropdownMenuItem onClick={logoutAction}>
          <Icon name='arrow-out-of-box' className='mr-2' size={18} />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
